"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _reactComponents = require("@cimpress/react-components");

var _sharedtypes = require("../../shared/sharedtypes");

var _WrappedSpinner = _interopRequireDefault(require("../../shared/WrappedSpinner"));

var _FulfillmentConfigurationErrorPage = _interopRequireDefault(require("../../shared/FulfillmentConfigurationErrorPage"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Shenanigans to make sure that we don't show empty rows and no pagination when number of rows is less than 10
var generateRowCountProps = function generateRowCountProps(_ref) {
  var filteredFulfillmentConfigurations = _ref.filteredFulfillmentConfigurations;
  var rowCountProps = filteredFulfillmentConfigurations.length === 0 ? {
    defaultPageSize: 10
  } : {
    minRows: 0
  };

  if (filteredFulfillmentConfigurations.length < 11 && !filteredFulfillmentConfigurations.length === 0) {
    rowCountProps.showPaginationBottom = false;
  }

  return rowCountProps;
};

var FulfillmentConfigurationList = function FulfillmentConfigurationList(_ref2) {
  var availableFulfillmentConfigurations = _ref2.availableFulfillmentConfigurations,
      filteredFulfillmentConfigurations = _ref2.filteredFulfillmentConfigurations,
      selectedFulfillmentConfiguration = _ref2.selectedFulfillmentConfiguration,
      selectFulfillmentConfiguration = _ref2.selectFulfillmentConfiguration,
      isLoadingFulfillmentConfigurations = _ref2.isLoadingFulfillmentConfigurations,
      loadFulfillmentConfigurations = _ref2.loadFulfillmentConfigurations,
      fulfillmentConfigurationLoadingError = _ref2.fulfillmentConfigurationLoadingError,
      showVersionsList = _ref2.showVersionsList,
      clearSelectedVersion = _ref2.clearSelectedVersion,
      onFulfillmentConfigurationSelected = _ref2.onFulfillmentConfigurationSelected;

  var _useTranslation = (0, _reactI18next.useTranslation)('fulfillmentConfigurationList'),
      t = _useTranslation.t; // If we're done loading and still have no fulfillment configurations, show the Fulfillment Configuration Error Page component


  if (!isLoadingFulfillmentConfigurations && availableFulfillmentConfigurations.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_FulfillmentConfigurationErrorPage["default"], {
      loadFulfillmentConfigurations: loadFulfillmentConfigurations,
      errorMessage: fulfillmentConfigurationLoadingError
    });
  }

  var currentFulfillmentConfigurationId = selectedFulfillmentConfiguration ? selectedFulfillmentConfiguration.fulfillmentConfigurationId : undefined;

  var isSelected = function isSelected(fulfillmentConfigurationId) {
    return fulfillmentConfigurationId === currentFulfillmentConfigurationId;
  };

  var toggleSelection = function toggleSelection(key, some, row) {
    // If the new selection is the same fulfillment configuation that's already selected,
    // we only need to switch the shown table to the versions table.
    // Otherwise, we need to do some cleanup beforehand.
    if (currentFulfillmentConfigurationId !== row.fulfillmentConfigurationId) {
      // Set the newly selected FC in the store
      selectFulfillmentConfiguration(_objectSpread({}, row)); // Remove the previously selected version, as it belonged to the old FC selection

      clearSelectedVersion(); // Clear out the selected FC URL in the parent, as the user as invalidated it

      onFulfillmentConfigurationSelected({
        fulfillmentConfigurationUrl: ''
      });
    } // Show the versions table


    showVersionsList();
  };

  return /*#__PURE__*/_react["default"].createElement(_WrappedSpinner["default"], {
    showSpinner: isLoadingFulfillmentConfigurations,
    spinnerSize: "large",
    spinnerClassName: "fcp-fulfillmentConfigurations__loadingSpinner"
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.ReactTablev6, (0, _extends2["default"])({
    className: "fcp-fulfillmentConfigurationsList__table",
    data: filteredFulfillmentConfigurations,
    columns: [{
      Header: t('table.nameHeader'),
      accessor: 'fulfillmentConfigurationName'
    }],
    loading: isLoadingFulfillmentConfigurations,
    sortable: false,
    selectable: true,
    selectType: "radio",
    keyField: "fulfillmentConfigurationId",
    isSelected: isSelected,
    toggleSelection: toggleSelection,
    showPageSizeOptions: false
  }, generateRowCountProps({
    filteredFulfillmentConfigurations: filteredFulfillmentConfigurations
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurations__actionButtons"
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
    className: "fcp-fulfillmentConfigurationsActionButtons__primaryButton",
    disabled: !selectedFulfillmentConfiguration,
    onClick: function onClick() {
      return showVersionsList();
    },
    type: "primary"
  }, t('selectVersionButton'))));
};

FulfillmentConfigurationList.propTypes = {
  availableFulfillmentConfigurations: _propTypes["default"].arrayOf(_sharedtypes.FulfillmentConfiguration).isRequired,
  filteredFulfillmentConfigurations: _propTypes["default"].arrayOf(_sharedtypes.FulfillmentConfiguration).isRequired,
  selectedFulfillmentConfiguration: _sharedtypes.FulfillmentConfiguration,
  selectFulfillmentConfiguration: _propTypes["default"].func.isRequired,
  isLoadingFulfillmentConfigurations: _propTypes["default"].bool.isRequired,
  loadFulfillmentConfigurations: _propTypes["default"].func.isRequired,
  fulfillmentConfigurationLoadingError: _propTypes["default"].string,
  showVersionsList: _propTypes["default"].func.isRequired,
  clearSelectedVersion: _propTypes["default"].func.isRequired,
  onFulfillmentConfigurationSelected: _propTypes["default"].func.isRequired
};
FulfillmentConfigurationList.defaultProps = {
  selectedFulfillmentConfiguration: undefined,
  fulfillmentConfigurationLoadingError: undefined
};
var _default = FulfillmentConfigurationList;
exports["default"] = _default;